import React, { Component } from 'react';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import './App.css';
import Index from './components/Index';
import Team from './components/Team';
import Video from './components/Video';
import Archive from './components/Archive';
import Resources from './components/Resources';

class App extends Component {
  render() {
    return (
      <Router history={browserHistory}>
        <Route path="/" component={Index} >
          <IndexRoute component={Index} />
        </Route>
        <Route path="/team" component={Team} >
          <IndexRoute component={Team} />
        </Route>
        <Route path="/video" component={Video} >
          <IndexRoute component={Video} />
        </Route>
        <Route path="/archive" component={Archive} >
          <IndexRoute component={Archive} />
        </Route>
        <Route path="/resources" component={Resources} >
          <IndexRoute component={Resources} />
        </Route>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js